import {
  CommentComposer,
  type CommentComposerProps,
} from './CommentComposer';
import { CommentReplyComposerFrame } from './CommentModalShell';
import type { CommentReplyTarget } from './comment-threading';

type ReplyCommentComposerProps = Omit<CommentComposerProps, 'compact'> & {
  compact?: boolean;
  onCancelReply: () => void;
  replyTarget: CommentReplyTarget;
};

export function ReplyCommentComposer({
  compact = false,
  onCancelReply,
  replyTarget,
  ...composerProps
}: ReplyCommentComposerProps) {
  return (
    <CommentReplyComposerFrame
      compact={compact}
      replyTarget={replyTarget}
      onCancel={onCancelReply}
    >
      <CommentComposer {...composerProps} compact />
    </CommentReplyComposerFrame>
  );
}
